import { snakeCase } from 'lodash';

export const enum StringCaseType {
  KebabCase = '-',
  SnakeCase = '_',
  NormalText = ' ',
}

export class StringUtils {
  static removeLastCharIf(
    text: string,
    predicate: (value: string) => boolean
  ): string {
    return predicate(text) ? text.substring(0, text.length - 1) : text;
  }

  static convertOtherCaseToTitleCase(
    text?: string,
    stringCaseType?: StringCaseType
  ): string | undefined {
    if (!text) return undefined;
    return text
      .split(stringCaseType ?? StringCaseType.KebabCase)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  static convertQueryToSingleString(
    query?: string | string[]
  ): string | undefined {
    if (!query) return undefined;
    return Array.isArray(query) ? query[0] : query;
  }

  static convertQueryToArrayString(
    query?: string | string[]
  ): string[] | undefined {
    if (!query) return undefined;
    return Array.isArray(query) ? query : [query];
  }

  /**
   * Converts text to lowercase snake_case.
   */
  static toSnakeCase(text: string | null | undefined): string | null {
    if (!text) return null;
    return snakeCase(text).toLowerCase();
  }

  static ignoreCaseEquals(
    text1?: string | null,
    text2?: string | null
  ): boolean {
    if (!text1 || !text2) return false;
    return text1.toLowerCase() === text2.toLowerCase();
  }

  static ignoreCaseInclude(
    text1?: string | null,
    text2?: string | null
  ): boolean {
    if (!text1 || !text2) return false;
    return text1.toLowerCase().includes(text2.toLowerCase());
  }
}
